import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
import type { JournalEntryDto } from "@/features/ledger/api/dto";

/** Détail d'une écriture avec toutes ses lignes débit/crédit (`GET /JournalEntries/{id}`). */
export const useJournalEntry = (journalEntryId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.LEDGER_JOURNAL_ENTRY_DETAIL(journalEntryId),
    queryFn: () =>
      fetchDataGet<JournalEntryDto>({
        url: ledgerEndpoints.journalEntries.detail(journalEntryId),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(journalEntryId),
  });
